module.exports = __webpack_public_path__ + "static/media/logo-black1.82a28ece.png";